import {ChangeDetectionStrategy, Component, DOCUMENT, Inject, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {Actions} from '@ngrx/effects';
import {AuthRedirectService, RoutingService, WindowRef} from '@spartacus/core';
import {LoginFormComponent, LoginFormComponentService} from '@spartacus/user/account/components';
import {BehaviorSubject, Observable, Subscription} from 'rxjs';
import {filter, map} from 'rxjs/operators';

import {AimoRoutingService} from '../../../cms-structure/routing/aimo-routing.service';
import {LOGINFAIL} from '../../../service/auth/login-logout-fail.action';
import {AimoSpinnerService} from '../../shared/spinner/aimo-spinner.service';
import {openCloseSpinner} from '../../shared/utils/spinner/aimo-spinner-utils';

import {AimoLoginFormComponentService} from './aimo-login-form-component.service';
import {AimoAuthService} from "../../../service/auth/aimo-auth.service";

@Component({
    selector: 'aimo-cx-login-form',
    templateUrl: './aimo-login-form.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AimoLoginFormComponent extends LoginFormComponent implements OnInit, OnDestroy {
    errorOnLogin$ = new BehaviorSubject(false);
    subscription = new Subscription();
    cdcNotActivated$: Observable<boolean>;


    constructor(
        protected service: LoginFormComponentService,
        protected actions: Actions,
        protected spinnerService: AimoSpinnerService,
        protected activatedRoute: ActivatedRoute,
        protected authRedirectService: AuthRedirectService,
        protected aimoRoutingService: AimoRoutingService,
        protected routingService: RoutingService,
        protected winRef: WindowRef,
        protected authService: AimoAuthService,
        protected route: ActivatedRoute,
        @Inject(DOCUMENT) private document: Document,
    ) {
        super(service);
        this.subscription.add(
            this.authService.isUserLoggedIn()
                .pipe(filter(Boolean))
                .subscribe(() => this.routingService.go('/')));
        const oldLogin = this.route.snapshot?.queryParamMap?.get('oldLogin');
        this.cdcNotActivated$ = (this.service as AimoLoginFormComponentService).isCDCLoginActivated(
            oldLogin === 'true'
        ).pipe(map((activated) => !activated));
    }

    ngOnInit(): void {
        this.spinnerService.setTitle('aimo.loading.loginForm');
        openCloseSpinner(this.document, false);
        this.subscription.add(
            this.actions.subscribe((action) => {
                if (action.type == LOGINFAIL) {
                    this.routingService.go('/login');
                    this.errorOnLogin$.next(true);
                }
                this.form.enable();
            }),
        );
        const gtmUrlParam = this.activatedRoute.snapshot.queryParamMap.get('_gl');
        if (gtmUrlParam) {
            this.authRedirectService.setRedirectUrl('/?_gl=' + gtmUrlParam);
        }
        if (this.route.snapshot.queryParamMap.get('autoLogin') === 'true') {
            this.doCDCLogin();
        }
        this.isUpdating$.subscribe(
            isUpdating => openCloseSpinner(this.document, isUpdating)
        );
    }

    doCDCLogin(): void {
        (this.service as AimoLoginFormComponentService).forwardToCLPLoginPage();
    }

    ngOnDestroy(): void {
        this.spinnerService.setTitle(null);
        this.subscription.unsubscribe();
    }

    onSubmit(): void {
        super.onSubmit();
    }

    getTextSuffix(): string {
        return this.aimoRoutingService.isPikatukku() ? '_pt' : '_tt';
    }

    gotoLogin(): void {
        this.document.location.reload();
    }

    public isLoginInProgress(): Observable<boolean> {
        return this.authService.isLoginInProgress();
    }

    protected getLoginTextKey(): string {
        return 'loginForm.signInCdcText' + this.getTextSuffix();
    }
}
